import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=c9c6e77a"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=c9c6e77a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports